import { render, staticRenderFns } from "./SplitSection.vue?vue&type=template&id=0358bfdc&"
import script from "./SplitSection.vue?vue&type=script&lang=js&"
export * from "./SplitSection.vue?vue&type=script&lang=js&"
import style0 from "./SplitSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SplitSection.vue"
export default component.exports